<template>
  <v-row>
    <v-col cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs :items="items" divider=">"/>
      <v-row>
        <v-col cols="12" lg="6">
          <v-toolbar flat class="theme rounded-t" dark v-if="timeoff">
            <v-toolbar-title>Timeoff Request Details({{timeoff.id}})</v-toolbar-title>
          </v-toolbar>
          <v-list three-line dense v-if="timeoff">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>User Details</v-list-item-title>
                <v-list-item-subtitle>{{timeoff.user_name}} ({{timeoff.user_id}})</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Approver Details</v-list-item-title>
                <v-list-item-subtitle>{{timeoff.approver_name}} ({{timeoff.approver_id}})</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Duration</v-list-item-title>
                <v-list-item-subtitle>
                  Start : {{timeoff.start_date}}
                  <br />
                  End : {{timeoff.end_date}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Leave Details</v-list-item-title>
                <v-list-item-subtitle>
                  {{timeoff.leave_type}}
                  <br />
                  ({{timeoff.description}})
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Status</v-list-item-title>
                <v-list-item-subtitle>{{timeoff.status}}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn icon small ripple class="success" @click="update(true)">
                  <v-icon>check</v-icon>
                </v-btn>

                <v-btn icon small ripple class="warning" @click="update(false)">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
     
        <v-col cols="12" lg="6">
          <v-toolbar class="theme rounded-t" flat dark v-if="timeoff && userAggregation">
            <v-toolbar-title>Leave summary for {{timeoff.user_name}}</v-toolbar-title>
          </v-toolbar>
          <v-list two-line dense>
            <template v-for="(item) in userAggregation">
              <v-list-item :key="item.id">
                <v-list-item-content>
                  <v-list-item-title>{{ item.leave_type }} : {{ item.start_date }} - {{item.end_date}}</v-list-item-title>
                  <v-list-item-subtitle>Status - {{item.status}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small ripple color="info" @click="info(item.id)">
                    <v-icon>info</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {mapGetters}  from 'vuex';

import {Actions}     from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component}   from '@/views/component';
import {Constants}   from '@/views/constants';

export default {
  name: Component.Protected.TimeOff.Edit,
  computed: {
    ...mapGetters(['userInfo']),
  },
  data: () => ({
    items: Breadcrumbs.TimeOff.Details,
    timeoffID: null,
    timeoff: null,
    userAggregation: null,
  }),
  methods: {
    getTimeoff() {
      this.$store.dispatch(Actions.TimeOff.GetByIdAndAggregation, this.timeoffID).then(res => {
        if (res.status === 200) {
          if (res.data.timeoff) {
            res.data.timeoff.start_date = this.formatFromDate(res.data.timeoff.start_date);
            res.data.timeoff.end_date = this.formatFromDate(res.data.timeoff.end_date);
            this.timeoff = res.data.timeoff;
          }
          this.userAggregation = [];
          if (res.data.userAgg) {
            res.data.userAgg.forEach(element => {
              element.start_date = this.formatFromDate(element.start_date);
              element.end_date = this.formatFromDate(element.end_date);
              this.userAggregation.push(element);
            });
          }
        }
      }).catch(err => {
        console.error(Constants.TimeOff.Messages.Error.Get, err);
        this.snackbarMessage = Constants.TimeOff.Messages.Error.Get;
        this.snackbar = true;
      });
    },
    info(id) {
      if (id && id !== this.timeoffID) {
        this.timeoffID = id;
        this.getTimeoff();
      }
    },
    update(ok) {
      const confirmation = confirm('Are you sure?');
      if (confirmation) {
        if (ok) {
          this.timeoff.status = Constants.TimeOff.Status.Approved;
        } else {
          this.timeoff.status = Constants.TimeOff.Status.Rejected;
        }
        let payload = {id: this.timeoffID, data: this.timeoff};
        this.$store.dispatch(Actions.TimeOff.Edit, payload).then(() => this.getTimeoff()).catch(err => {
          console.error(Constants.TimeOff.Messages.Error.Edit, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.TimeOff.Messages.Error.Edit;
        });

      } else return false;
    }
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return false;
    }

    this.timeoffID = this.$route.params.id;
    if (this.userInfo && this.userInfo.role) {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
      }
      this.getTimeoff();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => {
        if (this.userInfo.role !== Constants.Roles.HR) {
          this.$router.go(-1);
        }
        this.getTimeoff();
      });
    }
  }
};
</script>